import React, { useEffect } from 'react';
import { View, StyleSheet, ScrollView, useWindowDimensions } from 'react-native';
import Text from '../../components/text';
import drawerHoc from '../../components/drawerHOC/DrawerHOC';
import BankAccountTable from '../tenants/tenantOnboarding/screens/components/BankAccountTable';
import { tenantActions } from '../tenants/redux/tenant.actions';
import { useIsFocused } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import { COLORS, BORDER_RADIUS } from '../../constants/theme';

const BankAccount = ({ navigation }) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 767;
  const focused = useIsFocused();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(tenantActions.getBranchBankAccounts());
  }, [focused]);

  return (
    <ScrollView style={[styles.container, isMobile && styles.containerMobile]} showsVerticalScrollIndicator={false}>
      {/* Breadcrumb Header */}
      <Text style={styles.breadcrumbText}>Settings › Bank Accounts</Text>

      <View style={styles.headerRow}>
        <Text style={styles.pageTitle}>Bank Accounts</Text>
      </View>

      {/* Top Info Banner Card matching Figma */}
      <View style={styles.infoBanner}>
        <Text style={styles.infoTitle}>Manage added bank details</Text>
        <Text style={styles.infoBody}>
          Here is your added bank account details. Use these parameters to coordinate payouts and rent allocations.
        </Text>
      </View>

      {/* Main Bank Accounts Table Component */}
      <BankAccountTable />
    </ScrollView>
  );
};

export default drawerHoc({
  Component: BankAccount,
  showBackButton: true,
  backNavigation: 'Setting',
});

/* ================= STYLES ================= */

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: COLORS.appBg,
  },
  containerMobile: {
    padding: 14,
  },

  breadcrumbText: {
    fontSize: 12,
    color: '#9CA3AF',
    marginBottom: 6,
  },

  headerRow: {
    marginBottom: 18,
  },

  pageTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: COLORS.textPrimary,
  },

  /* INFO BANNER */
  infoBanner: {
    backgroundColor: '#F5F3FF',
    borderWidth: 1,
    borderColor: '#E0E7FF',
    borderRadius: BORDER_RADIUS.lg,
    padding: 16,
    marginBottom: 20,
  },
  infoTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#6C2BD9',
    marginBottom: 4,
  },
  infoBody: {
    fontSize: 12,
    color: '#4B5563',
    lineHeight: 18,
  },
});
